'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.cache = cache;
exports.set = set;
exports.get = get;
exports.remove = remove;
exports.prune = prune;
exports.deleteAllCacheEntries = deleteAllCacheEntries;

var _localforage = require('localforage');

var _localforage2 = _interopRequireDefault(_localforage);

var _localForageInMemoryMock = require('./local-forage-in-memory-mock');

var _localForageInMemoryMock2 = _interopRequireDefault(_localForageInMemoryMock);

var _log = require('./log');

var log = _interopRequireWildcard(_log);

var _environment = require('./environment');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The cache operates on a separate localforage store.
 * If the ExtendedAPIPlugin for webpack is used, then the cache store name will be adjusted to
 * contain the hash of the current build.
 */
var hash = typeof __webpack_hash__ === 'undefined' ? '___' : __webpack_hash__;
var store = (0, _environment.isPdf)() ? _localForageInMemoryMock2.default : _localforage2.default.createInstance({ name: 'cache' });

/**
 * In Memory cache for faster access.
 * @type {{}}
 */
var inMemory = {};

/*
 * Cache method, that uses a callback to generate data, if it is not yet in the cache.
 * @param key
 * @param lifetime
 * @param callback
 * @returns {*}
 */
function cache(key, lifetime, callback) {
    var write = false;

    if (!lifetime) {
        return callback();
    }

    return get(key).then(function (data) {
        if (!data) {
            write = true;
            return callback();
        }
        return data;
    }).then(function (data) {
        if (write) {
            /*
             * NOTE: The JSON.parse/JSON.stringify procedure below effectively deep-clones
             *       the given object structure. This is done to prevent race conditions
             *       when the data is modified directly after it is received.
             *       The race condition is possible because this method does not wait until
             *       the data has been written to the cache before it returns it: Data is
             *       written to the cache in the background, whenever the browser has some
             *       time to spare. Because Objects are passed by reference in Javascript and
             *       because the object may have been changed by the time the data is written
             *       to the cache the only two ways to ensure a consistent cache state are
             *         1. Wait until everything is written to the cache before continuing
             *         2. Clone the Data before writing to cache
             *       Because waiting for what essentially should be a background operation
             *       on every request is costly the second approach has been used.
             */
            set(key, JSON.parse((0, _stringify2.default)(data)), lifetime);
        }

        return data;
    }, function (e) {
        log.error('cache', 'cache', e);
        throw e;
    });
}

/**
 * Sets a value in the cache.
 * @param key
 * @param value
 * @param lifetime
 * @returns {*}
 */
function set(key, value, lifetime) {
    var cache = { data: value, expires: new Date().getTime() + lifetime, hash: hash };
    inMemory[key] = cache;
    return store.setItem(key, cache).catch(function (e) {
        return log.error('cache', 'set', e);
    });
}

/**
 * Gets a certain cache entry.
 * This method returns a Promise that will resolve either with the value of the cache entry
 * or `null`, if there is no valid cache entry.
 * @param key
 */
function get(key) {
    var promise = inMemory[key] ? _promise2.default.resolve(inMemory[key]) : store.getItem(key);
    return promise.then(function (cached) {
        if (!cached || cached.expires < new Date().getTime() || cached.hash !== hash) {
            return remove(key).then(function () {
                return null;
            });
        }

        inMemory[key] = cached;
        return cached.data;
    }, function (e) {
        return log.error('cache', 'get', e);
    });
}

/**
 * Returns the given key from the cache.
 * @param key
 * @returns {*}
 */
function remove(key) {
    if (inMemory[key]) {
        delete inMemory[key];
    }

    return store.removeItem(key).catch(function (e) {
        return log.error('cache', 'remove', key, e);
    });
}

/**
 * Removes all old values from the cache.
 */
function prune() {
    return store.keys().then(function (keys) {
        var promises = keys.map(function (key) {
            return store.getItem(key).then(function (item) {
                if (!item || !item.expires || !item.hash || !item.data || item.expires < new Date().getTime() || item.hash !== hash) {
                    log.debug('cache', 'prune', 'removing', key, {
                        itemEmpty: !item,
                        expiryEmpty: item && !item.expires,
                        hashEmpty: item && !item.hash,
                        dataEmpty: item && !item.hash,
                        expired: item && item.expires && item.expires < new Date().getTime(),
                        hashMismatch: item && item.hash && item.hash !== hash
                    });
                    return remove(key);
                }

                return _promise2.default.resolve();
            }, function (e) {
                return log.error('cache', 'prune', e);
            });
        });
        return _promise2.default.all(promises);
    }, function (e) {
        return log.error('cache', 'prune', e);
    });
}

/**
 * Deletes all cache entries.
 * @returns {Promise.<TResult>}
 */
function deleteAllCacheEntries() {
    return store.keys().then(function (keys) {
        return keys.map(function (key) {
            return remove(key);
        });
    }).then((0, _keys2.default)(inMemory).map(function (key) {
        return remove(key);
    }));
}